/*
 * @LastEditors: boqodo
 * @Author: boqodo
 * @Date: 2025-03-12 17:15:35
 * @LastEditTime: 2025-04-09 10:04:58
 * @Description: filecontent
 * @FilePath: /h5-astx-app/src/App.js
 */
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import Home from './pages/Home';
import ManualSelection from './pages/ManualSelection';
import RandomSelection from './pages/RandomSelection';
import Dictation from './pages/Dictation';
import AiDictation from './pages/AiDictation';
import AiDictationManual from './pages/AiDictationManual';
import AiDictationTextbook from './pages/AiDictationTextbook';
import AiDictationRandom from './pages/AiDictationRandom';
import AiDictationStart from './pages/AiDictationStart';
import Settings from './pages/Settings';
import FontSizeSettings from './pages/FontSizeSettings';
import { SettingsProvider } from './hooks/useSettings';

// 导入字体图标
import '@fortawesome/fontawesome-free/css/all.min.css';

function App() {
  return (
    <SettingsProvider>
    <Router>
      <Routes>
        <Route path="/" element={
          <MainLayout>
            <Home />
          </MainLayout>
        } />
         <Route path="/settings" element={
            <MainLayout>
             <Settings />
          </MainLayout>
          } />
         <Route path="/font-size" element={<FontSizeSettings />} />
        <Route path="/manual-selection" element={
          <ManualSelection />
        } />
        <Route path="/random-selection" element={
          <RandomSelection />
        } />
        <Route path="/dictation" element={
          <Dictation />
        } />
        <Route path="/ai-dictation" element={
          <AiDictation />
        } />
        <Route path="/ai-dictation/manual" element={
          <AiDictationManual />
        } />
        <Route path="/ai-dictation/textbook" element={
          <AiDictationTextbook />
        } />
        <Route path="/ai-dictation/random" element={
          <AiDictationRandom />
        } />
        <Route path="/ai-dictation/start" element={
          <AiDictationStart />
        } />
                {/* 听写相关路由 */}
                <Route path="/dictation" element={<Dictation />} />
        <Route path="/check-result" element={<Dictation mode="check" />} />
      </Routes>
    </Router>
    </SettingsProvider>
  );
}

export default App;